import { IconProps } from '@/shared/lib/types'
import { getStatusColors } from '@/shared/utils/getStatusColors'

export const DealIcon = ({ status, className }: IconProps) => {
  const { fillColor, strokeColor } = getStatusColors(status)

  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="40" height="40" rx="20" fill={`${fillColor}`} />
      <path
        d="M23.5 11H17C13.6863 11 11 13.6863 11 17V23.5C11 26.8137 13.6863 29.5 17 29.5H23.5C26.8137 29.5 29.5 26.8137 29.5 23.5V17C29.5 13.6863 26.8137 11 23.5 11Z"
        stroke={`${strokeColor}`}
        strokeWidth="1.5"
      />
      <path
        d="M14.75 20.6771C14.5872 20.677 14.4289 20.7255 14.2988 20.8154C14.1687 20.9053 14.0741 21.0316 14.0291 21.1752C13.9842 21.3189 13.9914 21.4721 14.0497 21.6117C14.108 21.7513 14.2141 21.8696 14.3522 21.9488L16.3661 23.7986C16.5067 23.9276 16.6974 24.0001 16.8961 24C17.0949 23.9999 17.2855 23.9274 17.426 23.7982C17.5664 23.6691 17.6453 23.494 17.6453 23.3115C17.6452 23.1289 17.5662 22.9539 17.4256 22.8248L16.5857 22.0541H22.2425C22.4412 22.0541 22.6318 21.9816 22.7723 21.8526C22.9128 21.7235 22.9918 21.5485 22.9918 21.366C22.9918 21.1835 22.9128 21.0084 22.7723 20.8794C22.6318 20.7503 22.4412 20.6778 22.2425 20.6778L14.75 20.6771ZM25.25 19.3222C25.4128 19.3223 25.5711 19.2738 25.7012 19.1839C25.8313 19.0941 25.9259 18.9677 25.9709 18.8241C26.0158 18.6804 26.0086 18.5272 25.9503 18.3876C25.892 18.248 25.7859 18.1297 25.6478 18.0505L23.6339 16.2014C23.5643 16.1375 23.4816 16.0869 23.3907 16.0523C23.2997 16.0177 23.2023 16 23.1039 16C23.0055 16 22.908 16.0179 22.8171 16.0525C22.7262 16.0871 22.6436 16.1378 22.574 16.2018C22.5045 16.2657 22.4493 16.3416 22.4117 16.4251C22.3741 16.5086 22.3547 16.5981 22.3547 16.6885C22.3548 16.7789 22.3742 16.8684 22.4119 16.9519C22.4496 17.0354 22.5048 17.1113 22.5744 17.1752L23.4143 17.9459H17.7575C17.5588 17.9459 17.3682 18.0184 17.2277 18.1474C17.0872 18.2765 17.0082 18.4515 17.0082 18.634C17.0082 18.8165 17.0872 18.9916 17.2277 19.1206C17.3682 19.2497 17.5588 19.3222 17.7575 19.3222H25.25Z"
        fill={`${strokeColor}`}
      />
    </svg>
  )
}
